import * as s from "./website-black-guide-details.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {ProgressBarSemiComponent} from "../../../../../../components/global/progressbar/semi/ProgressBarSemiComponent";
import {TooltipComponent} from "../../../../../../components/global/tooltip/TooltipComponent";
import {
    LoaderObjectBlockComponent
} from "../../../../../../components/global/loader/objects/block/LoaderObjectBlockComponent";
import {IWebsitePostModel} from "../../../../../../../models/website/posts/IWebsitePostModel";
import {Resources} from "../../../../../../../resources/Resources";

export class WebsiteBlackGuideDetailsComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackGuideDetails}"></div>`;
    }

    renderLoader() {
        this.clearAll();

        this.addClass(s.loading);
        //language=HTML
        this.append(`
            <div class="${s.loader}">
                ${this.draw(new LoaderObjectBlockComponent(true))}
            </div>
        `);
    }

    renderDetails(post: IWebsitePostModel) {
        this.clearAll();
        this.removeClass(s.loading);

        this.renderScore(post);
        this.renderPlan();
    }

    renderScore(post: IWebsitePostModel) {
        //language=HTML
        this.append(`
            <div class="${s.score}">
                <div class="${s.progress}">
                    <div class="${s.semi}">
                        ${this.draw(new ProgressBarSemiComponent({
                            valueFontSize: 15,
                            value: post.contentRating,
                            midValue: 32,
                            midEndValue: 101,
                            goodValue: 70,
                            maxValue: 100,
                            goodColor: "#3ECE80",
                            badColor: "var(--red)",
                            midColor: "#ECA336",
                            strokeWidth: 10,
                            title: false,
                            size: 70,
                            hideValue: true,
                            arc: true
                        }))}
                    </div>
                </div>
                <div>
                    <div class="${s.title}">
                        ${Resources.t("words.contentScore")}
                        ${this.draw(new TooltipComponent(Resources.t("words.contentScoreExplanation")))}
                    </div>
                    <div class="${s.description}">
                        ${Resources.t("words.measuredWithSedestral")}
                    </div>
                </div>
            </div>
        `);
    }

    renderPlan() {
        //language=HTML
        let plan = this.append(`
            <div class="${s.plan}">
                <div class="${s.subTitle}">
                    ${Resources.t("words.summary")}
                </div>
                <div class="${s.entries}"></div>
            </div>
        `);

        let entriesContainer = plan.el(s.entries);
        let sections = document.querySelectorAll('article h2');
        let entries = [];
        let anchor = window.location.hash.substring(1);

        sections.forEach(section => {
            //language=HTML
            let link = entriesContainer.append(`
                <a href="#${section.id}" class="${s.entry}" data-none="true">
                    <div class="${s.dot}"></div>
                    ${section.textContent}
                </a>
            `);

            link.onClick(() => {
                if (section instanceof HTMLElement) {
                    section.click();
                }
            });

            if (anchor == section.id) {
                this.timeOut(() => section.scrollIntoView(), 100)
            }

            entries.push({
                id: section.id,
                el: link.getHTMLElement(),
                section: section
            });
        });


        function updateVisibleEntry() {
            let closest = null;
            let minDistance = Infinity;

            entries.forEach(entry => {
                const rect = entry.section.getBoundingClientRect();
                const distance = Math.abs(rect.top);

                if (rect.top <= window.innerHeight && distance < minDistance) {
                    minDistance = distance;
                    closest = entry;
                }
            });

            entries.forEach(entry => {
                entry.el.removeAttribute('data-visible');
            });

            if (closest) {
                closest.el.setAttribute('data-visible', 'true');
            }
        }

        this.putListener(window, 'scroll', updateVisibleEntry);
        this.putListener(window, 'resize', updateVisibleEntry);
        updateVisibleEntry();
    }
}